import { Theme } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Link, Text } from 'platform-components';
import React, { useState, useCallback } from 'react';

import IconArrow from 'common.components/icon/__arrow/icon__arrow';

import SidebarThemes from '../../library.sidebar-themes/sidebar-themes';

import './subject-page__subject-themes.scss';

interface Props {
    plainThemes: Array<Theme>;
    promotedThemes: Array<Theme>;
    shouldShowActualThemes: boolean;
}

const SubjectThemes = ({ plainThemes, promotedThemes, shouldShowActualThemes }: Props) => {
    const [isThemesOpened, setThemesOpened] = useState(true);
    const onMenuToggle = useCallback(() => {
        setThemesOpened(!isThemesOpened);
    }, [isThemesOpened]);

    if (!plainThemes.length && !promotedThemes.length) {
        return null;
    }

    return (
        <div className={b('subject-page', 'themes', { mobile: true })}>
            <div className={b('subject-page', 'themes-menu-link', { opened: isThemesOpened })}>
                <Link onClick={onMenuToggle} pseudo>
                    <Text id="library.themesMenuTitle" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
                    <IconArrow direction={isThemesOpened ? IconArrow.DIRECTIONS.TOP : IconArrow.DIRECTIONS.BOTTOM} />
                </Link>
            </div>
            <div className={b('subject-page', 'themes-subject', { opened: isThemesOpened })}>
                {(promotedThemes.length > 0 || shouldShowActualThemes) && (
                    <SidebarThemes shouldAddActualThemes={shouldShowActualThemes} themes={promotedThemes} />
                )}
                {plainThemes.length > 0 && <SidebarThemes themes={plainThemes} />}
            </div>
        </div>
    );
};

export default SubjectThemes;
